<script lang="ts">
    
    import { onMount } from "svelte";
    import { Modal, Button, Table, ModalHeader, ModalBody, TabPane, Icon } from "sveltestrap";
    import type { Room } from "../../Model/Room";
    import { roomsFactory, roomsService } from "../../Services";
    import RoomForm from "../Rooms/RoomForm.svelte";
    import RoomIcon from "../Rooms/RoomIcon.svelte";
    import DisabledBadge from "../Shared/DisabledBadge.svelte";
    import EnabledBadge from "../Shared/EnabledBadge.svelte";
    import Picture from "../Shared/Picture.svelte";
    import Watch from "../Watch.svelte";

    export let accountId: string;

    onMount(mount);

    let rooms: Room[] = [];
    let openRoomModal = false;
    let isNew = false;
    let editRoom: Room;

    async function mount(): Promise<void> {
        rooms = await roomsService.getAccountRooms(accountId);
    }

    function onCreateRoom(): void {
        isNew = true;
        editRoom = roomsFactory.createRoom(accountId);
        openRoomModal = true;
    }

    function toggleRoomModal(): void {
        openRoomModal = !openRoomModal;
    }

    function onSaved(): void {
        if (isNew) {
            rooms = [...rooms, editRoom];
        }
        openRoomModal = false;
    }

    function onEdit(room: Room): void {
        isNew = false;
        editRoom = room;
        openRoomModal = true;
    }

    async function onRemove(): Promise<void> {
        if (!confirm(`¿Seguro que desea eliminar la sala "${editRoom.name.value}".?`)) {
            return;
        }
        try {
            await roomsService.removeRoom(editRoom.id);
            rooms = rooms.filter(({ id }) => id !== editRoom.id);
            openRoomModal = false;
        } catch (error) {
            console.error(error);
        }
    }

</script>

<Button color="primary" type="button" size="sm" on:click={onCreateRoom}>
    <RoomIcon /> Nueva sala
</Button>

<Table>
    <thead>
        <tr>
            <th style="width: 80px;"></th>
            <th>Nombre</th>
            <th>Modo</th>
            <th>Estado</th>
            <th>T/M</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        {#each rooms as room}
            <tr>
                <td style="width: 80px;">
                    <div class="room-picture">
                        <Picture id={room.pictureId} />
                    </div>
                </td>
                <td>
                    <span class="link-look" on:click={() => onEdit(room)}>
                        <Watch state={room.name} />
                    </span>
                </td>
                <td>
                    <Watch state={room.integratedDisplay} let:value>
                        {value ? 'Piscina' : 'Teatro'}
                    </Watch>
                </td>
                <td>
                    <Watch state={room.enabled} let:value>
                        {#if value}
                            <EnabledBadge text="Activada" />
                        {:else}
                            <DisabledBadge text="Desactivada" />
                        {/if}
                    </Watch>
                </td>
                <td>
                    <Watch state={room.secondsBetweenMessages} /> segundos
                </td>
                <td class="text-end">
                    <div class="btn-group">
                        <Button type="button" color="primary" outline size="sm" on:click={() => onEdit(room)}>
                            <Icon name="pencil-fill" />
                        </Button>
                        <a href="/monitor/{room.id}" target="_blank" class="btn btn-outline-primary btn-sm">
                            <Icon name="tv-fill" />
                        </a>
                        <a href="/room/{room.id}/print-qr" target="_blank" class="btn btn-outline-primary btn-sm">
                            <Icon name="grid-fill" />
                        </a>
                    </div>
                </td>
            </tr>
        {/each}
    </tbody>
</Table>

<Modal isOpen={openRoomModal} size="lg">
    <ModalHeader toggle={toggleRoomModal}>
        <RoomIcon /> Editar sala
    </ModalHeader>
    <ModalBody>
        <RoomForm room={editRoom} on:saved={onSaved}>
            {#if !isNew}
                <TabPane tabId="del" tab="Eliminar" class="pt-3">
                    <Button type="button" color="danger" on:click={onRemove}>
                        Eliminar
                    </Button>
                </TabPane>
            {/if}
        </RoomForm>
    </ModalBody>
</Modal>
